module.exports = __webpack_public_path__ + "img/payment-method-icon.a2c3961d.svg";